export default __webpack_public_path__ + "static/media/info.d79cba24.png";